import { createRoot } from 'react-dom/client';
import './styles/index.css';
import { Provider } from "react-redux";
import { store } from "./redux/store"
import { ThemeProvider } from "@mui/material";
import './i18n/i18n';
import AuthProvider from './auth/authProvider';
import { AppStyle } from './helpers/appStyle';
import { appStyleMode } from './helpers/clientConfigs';
import WebsiteContent from './components/content/websiteContent';
import MobileContent from './components/content/mobileContent';
import { ThemeMobile } from './styles/themeMobile';
import { ThemeBlue } from './styles/themeBlue';
import { ThemeFormada } from './styles/themeFormada';

declare let window: any;

const startApp = () => {
  const container = document.getElementById('root');
  if (appStyleMode === AppStyle.Mobile) {
    document.body.classList.add('mobile-body');
    container.classList.add('mobile-root');
  }
  else if (appStyleMode === AppStyle.Formada) {
    document.body.classList.add('formada-body');
    container.classList.add('root-container');
  }
  else {
    document.body.classList.add('blue-body');
  }

  const root = createRoot(container);
  root.render(appContent());
}

const getTheme = () => {
  if (appStyleMode === AppStyle.Mobile)
    return ThemeMobile;
  if (appStyleMode === AppStyle.Formada)
    return ThemeFormada;

  return ThemeBlue;
}

const getContent = () => {
  if (appStyleMode === AppStyle.Mobile)
    return (<MobileContent />);

  return (<WebsiteContent />);
}

const appContent = () => {
  return (
    <ThemeProvider theme={getTheme()}>
      <Provider store={store}>
        <AuthProvider>
          {getContent()}
        </AuthProvider>
      </Provider>
    </ThemeProvider>
  );
}

if (!window.cordova) {
  startApp()
}
else {
  document.addEventListener('deviceready', startApp, false);
}